import { render, staticRenderFns } from "./BankTransfersTable.vue?vue&type=template&id=2a64dafc&scoped=true&"
import script from "./BankTransfersTable.vue?vue&type=script&lang=js&"
export * from "./BankTransfersTable.vue?vue&type=script&lang=js&"
import style0 from "./BankTransfersTable.vue?vue&type=style&index=0&id=2a64dafc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64dafc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAlert,VChip,VContainer,VDataTable,VIcon,VSelect,VTextField,VToolbar})
